module.exports = __webpack_public_path__ + "img/popup-bg-2.040d3ab.png";